const loadedScriptUrls = new Map();

function loadGatewayScript(url) {
    if (!url) {
        return Promise.reject(new Error('card-swipe: gateway javascript url is required'));
    }
    if (loadedScriptUrls.has(url)) {
        return loadedScriptUrls.get(url);
    }

    const loading = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = url;
        script.async = false;
        script.addEventListener('load', () => resolve());
        script.addEventListener('error', () => {
            script.remove();
            loadedScriptUrls.delete(url);
            reject(new Error('card-swipe: gateway javascript failed to load'));
        });
        document.head.appendChild(script);
    });

    loadedScriptUrls.set(url, loading);
    return loading;
}

function createCardSwipe(gatewayJavascriptUrl, gatewayApi) {
    return loadGatewayScript(gatewayJavascriptUrl).then(() => {
        const HostedTokenization = window.HostedTokenization;
        if (!HostedTokenization) {
            throw new Error('card-swipe: HostedTokenization is unavailable');
        }
        const hosted = new HostedTokenization(gatewayApi);
        hosted.name = 'token_window';
        return hosted.create('swipe');
    });
}

export { createCardSwipe };
